<template>
    <spouse-partner-login-assistance v-bind="childComponentProps"></spouse-partner-login-assistance>
</template>
<script>
    import { loginConstants } from '../login.constants';
    import SpousePartnerLoginAssistance from "./SpousePartnerLoginAssistance";

    export default {
        name: 'SpousePartnerResetPassword',
        components: { SpousePartnerLoginAssistance },
        data: () => ({
            loginConstants,
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        computed: {
            childComponentProps() {
                const {
                    changeCardState,
                    toggleProgressIndicator,
                    isSubmitting,
                    returnToLogin,
                } = this;

                return {
                    changeCardState,
                    toggleProgressIndicator,
                    isSubmitting,
                    returnToLogin,
                    recoveryType: loginConstants.spousePartnerLoginAssistance.PASSWORD,
                };
            },
        },
    };
</script>
